import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { BarcodedUnit } from './BarcodedUnit'
import { ParcelOrder } from './ParcelOrder'

export class ParcelOrderBarcodedUnit extends Base {
  @Expose({ name: 'unit' })
  @Transform(({ unit }) => unit?.guid)
  guid: string = ''

  @Type(() => ParcelOrder)
  order?: ParcelOrder

  @Type(() => BarcodedUnit)
  unit?: BarcodedUnit
}
